import { useState } from "react";
import { EnquiryModal } from "@/components/wve/EnquiryModal";

export const PageCTA = ({ context, title = "Let's make it happen.", subtitle }) => {
  const [open, setOpen] = useState(false);

  return (
    <section className="bg-[#E80042] text-white py-20" data-testid="page-cta-section">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 flex flex-wrap items-center justify-between gap-8">
        <div>
          <h2 className="font-display uppercase text-4xl sm:text-6xl tracking-tight">{title}</h2>
          {subtitle && <p className="text-white/90 mt-3 max-w-md">{subtitle}</p>}
        </div>
        <div className="flex flex-wrap gap-4">
          <button
            onClick={() => setOpen(true)}
            data-testid="page-cta-enquire"
            className="bg-[#0A0A0A] text-white font-grotesk font-bold text-lg px-10 py-5 rounded-full hover:bg-white hover:text-[#0A0A0A] transition-colors duration-300 active:scale-95"
          >
            Enquire Now →
          </button>
          <a
            href="tel:01277280512"
            data-testid="page-cta-phone"
            className="border-2 border-white text-white font-grotesk font-bold text-lg px-10 py-5 rounded-full hover:bg-white hover:text-[#E80042] transition-colors duration-300"
          >
            01277 280 512
          </a>
        </div>
      </div>
      <EnquiryModal open={open} onClose={() => setOpen(false)} context={context} />
    </section>
  );
};
